module.exports = __webpack_public_path__ + "fc61ccf476a6b597d1aca68489ab2750.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/games/Space-Marine_1.jpg
// module id = 270
// module chunks = 0